export default "__VITE_ASSET__C$jSYUUc__"